import React from 'react'
import "./home.css"
import BigButton from '../utils/BigButton/BigButton'
import { Link } from 'react-router-dom'
import { useLangContext } from '../../Context/LangContext'
import homeTexts from '.././utils/Texts/homeTexts.json'

import MobileVideo from './video/AFZ02VERTICAL.mp4'
import { useEffect, useState } from 'react'

import ModalRent from './ModalRent'

const HomeMobile = () => {
const { selectedLanguage } = useLangContext()
const text = homeTexts[selectedLanguage];
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

useEffect(()=>{
  window.scrollTo(0,0);
},[])

  return (
   <>
   
   
   
  
    <div className='homeBackgound'>
      <video autoPlay playsInline muted className='home-video'>
        <source src={MobileVideo} type='video/mp4' />
      </video>
      <div className='gradient'>
      <div className='hero-mobile'>
        <div className='homeTitle-mobile'>
        <h1>{text.title1}<br></br>{text.title2}</h1>
        </div>
        <div className='mobile-button-box'>
        <button onClick={toggleModal} className="dark-button-mobile-home">{text.productButton}</button>
        <Link to="/contacto">
        <BigButton className="dark-button-mobile-home" name={text.contactButton} />
        </Link>
        </div>
    
      </div>
      </div>
      {isModalOpen && (
          <ModalRent toggleModal={toggleModal}/>
      )}
    </div>

 
    </>
   
  )
}

export default HomeMobile
